import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { ProjectProvider } from './context/ProjectContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import SignIn from './pages/auth/SignIn';
import SignUp from './pages/auth/SignUp';
import VerifyCode from './pages/auth/VerifyCode';
import ForgotPassword from './pages/auth/ForgotPassword';
import MainLayout from './layout/MainLayout';
import Home from './pages/Home';
import Dashboard from './pages/dashboard/Dashboard';
import PortfolioOverview from './pages/PortfolioOverview';
import AssetCockpit from './pages/AssetCockpit';
import StrategyDesigner from './pages/StrategyDesigner';
import CapacityMarket from './pages/CapacityMarket';
import InvestorReports from './pages/InvestorReports';
import EmissionFactors from './pages/EmissionFactors';
import EmissionActivity from './pages/EmissionActivity';
import ProjectMembers from './pages/ProjectMembers';
import Projects from './pages/Projects';
import ApiKeys from './pages/ApiKeys';
import Settings from './pages/Settings';
import DebugView from './pages/DebugView';
import TestTabView from './pages/TestTabView';
import ComingSoon from './pages/ComingSoon';
import ProjectInvitation from './pages/ProjectInvitation';
import Wiki from './pages/Wiki';


import OnboardingWorkflow from './pages/workflow/onboarding/OnboardingWorkflow';
import ScopeBoundariesWorkflow from './pages/workflow/scope-boundaries/ScopeBoundariesWorkflow';
import MaterialityAnalysisWorkflow from './pages/workflow/materiality_analysis/MaterialityAnalysisWorkflow';
import DataCollectionWorkflow from './pages/workflow/data_collection/DataCollectionWorkflow';
import CalculationWorkflow from './pages/workflow/calculation/CalculationWorkflow';
import ESRSDisclosuresWorkflow from './pages/workflow/esrs_disclosures/ESRSDisclosuresWorkflow';
import DraftReportWorkflow from './pages/workflow/draft_report/DraftReportWorkflow';
import SignOffWorkflow from './pages/workflow/sign-off/SignOffWorkflow';
import AuditQAWorkflow from './pages/workflow/audit_qa/AuditQAWorkflow';
import PublishWorkflow from './pages/workflow/publish/PublishWorkflow';
import AdvancedComplianceWorkflow from './pages/workflow/advanced_compliance/AdvancedComplianceWorkflow';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <ProjectProvider>
        {({ clearAllProjects, fetchProjects }) => (
          <AuthProvider onLogout={clearAllProjects} onLogin={fetchProjects}>
            <Toaster position="top-right" reverseOrder={false} />
            <Routes>
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/verify-code" element={<VerifyCode />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/project-invitation" element={<ProjectInvitation />} />

            <Route path="/" element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Home />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="portfolio-overview" element={<PortfolioOverview />} />
              <Route path="asset-cockpit" element={<AssetCockpit />} />
              <Route path="strategy-designer" element={<StrategyDesigner />} />
              <Route path="capacity-market" element={<CapacityMarket />} />
              <Route path="investor-reports" element={<InvestorReports />} />
              <Route path="emission-activity" element={<EmissionActivity />} />
              <Route path="emission-factors" element={<EmissionFactors />} />
              <Route path="members" element={<ProjectMembers />} />
              <Route path="projects" element={<Projects />} />
              <Route path="api-keys" element={<ApiKeys />} />
              <Route path="settings" element={<Settings />} />
              <Route path="wiki" element={<Wiki />} />
              <Route path="wiki/*" element={<Wiki />} />
              <Route path="debug" element={<DebugView />} />
              <Route path="test-tabview" element={<TestTabView />} />
              <Route path="coming-soon" element={<ComingSoon />} />
              <Route path="workflow/onboarding" element={<OnboardingWorkflow />} />
              <Route path="workflow/scope-boundaries" element={<ScopeBoundariesWorkflow />} />
              <Route path="workflow/materiality-analysis" element={<MaterialityAnalysisWorkflow />} />
              <Route path="workflow/data-collection" element={<DataCollectionWorkflow />} />
              <Route path="workflow/calculation" element={<CalculationWorkflow />} />
              <Route path="workflow/esrs_disclosures" element={<ESRSDisclosuresWorkflow />} />
              <Route path="workflow/draft_report" element={<DraftReportWorkflow />} />
              <Route path="workflow/sign-off" element={<SignOffWorkflow />} />
              <Route path="workflow/audit_qa" element={<AuditQAWorkflow />} />
              <Route path="workflow/publish" element={<PublishWorkflow />} />
              <Route path="workflow/advanced-compliance" element={<AdvancedComplianceWorkflow />} />
              
            </Route>

            {/* Catch-all route for 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          </AuthProvider>
        )}
      </ProjectProvider>
    </Router>
  );
}

export default App;
